export default "__VITE_ASSET__BwHgpc68__"